<iframe
  *ngIf="reportDesignerUrl"
  #designerFrame
  [src]="reportDesignerUrl"
  width="100%"
  height="100%"
  name="Report Designer Frame"
  title="Report Designer"
  allow="clipboard-read; clipboard-write"
  referrerpolicy="origin"
  class="flex-grow-1"
  (load)="onFrameLoad(designerFrame)">
</iframe>



// WEBPACK FOOTER //
// ./src/app/developer/reporting/report-designer/report-designer.component.html